export const urlMappings = {
    'home': '/',
    'calcApp': '/hesap-makinesi',
    'factorial': '/faktoriyel',
    'percentage': 'https://yuzde.hesaplama.vip/',
    'sqrt': 'https://karekok.hesaplama.vip/',
    'gcdlcm': '/ebob-ekok',
    'combination': '/kombinasyon',
    'permutation': '/permutasyon',
    'area': '/alan-hesaplama',
    'volume': '/hacim-hesaplama',
    'perimeter': '/cevre-hesaplama',
    'primeFactor': '/asal-carpan',
    'squareMeter': '/metrekare',
    'baseConversion': '/taban-donusumu',
    'inch': '/inc',
    'mile': '/mil',
    'power': '/uslu-sayi',
    'ratio': '/oran',
    'modular': '/moduler',
    'gradeCalculator': '/ders-notu-hesaplama',
    'random': '/rastgele-sayi',
    'pronunciation': 'https://sayiokunusu.hesaplama.vip/',
    'stdDev': '/standart-sapma',
    'waterNeed': '/gunluk-su-ihtiyaci',
    'idealWeight': '/ideal-kilo',
    'calorieNeed': '/kalori-ihtiyaci',
    'macroNutrient': '/makro-besin',
    'proteinNeed': '/protein-ihtiyaci',
    'carbNeed': '/karbonhidrat-ihtiyaci',
    'fatNeed': '/yag-ihtiyaci',
    'goldenRatio': '/altin-oran',
    'bmr': '/bazal-metabolizma-hizi',
    'babyHeight': '/bebek-boyu',
    'babyWeight': '/bebek-kilosu',
    'waistHipRatio': '/bel-kalca-orani',
    'birthDate': '/dogum-tarihi',
    'smokingCost': '/sigara-maliyeti',
    'bmi': '/vucut-kitle-indeksi',
    'bodyFat': '/vucut-yag-orani',
    'zekat': '/zekat-hesaplama',
    'wordCount': '/kelime-sayisi',
    'daysCalculator': '/kac-gun-oldu-hesaplama',
    'gpaCalculator': '/vize-final-ortalama-hesaplama',
    'priceIncrease': '/zam-hesaplama',
    'goldCalculator': 'https://altin.hesaplama.vip/',
    'dollarEuroCalculator': '/dolar-euro-cevirici',
    'tlDolarCalculator': '/tl-dolar-cevirici',
    'euroDolarCalculator': '/euro-dolar-donusturucu',
    'tlEuroCalculator': '/tl-euro-cevirici',
    'loremIpsum': '/lorem-ipsum-uretici',
    'cryptoCalculator': '/kripto-kar-zarar-hesaplama',
    'dataUnitConverter': '/veri-birimi-cevirici',
    'weightUnitConverter': '/agirlik-birimi-donusturucu',
    'energyUnitConverter': '/enerji-birimi-donusturucu',
    'lengthUnitConverter': '/uzunluk-birimi-donusturucu',
    'metabolizmaYasi': '/metabolizma-yasi',
    'liseMezuniyet': '/lise-mezuniyet-puani',
    'tusPuan': '/tus-puan-hesaplama',
    'tytPuan': '/tyt-puan-hesaplama',
    'klimaBtu': '/klima-btu-hesaplama',
    'yasHesaplama': '/yas-hesaplama',
    'yumurtlamaDonemi': '/yumurtlama-donemi-hesaplama',
    'cryptoCurrencyConverter': '/kripto-para-donusturucu',
    'yoldaGecenZaman': '/yolda-gecen-zaman-hesaplama',
    'dailyRentalIncome': '/gunluk-ev-kiralama-kazanc-hesaplama',
    'elektrikFaturasi': '/elektrik-faturasi-hesaplama',
    'dogalgazFaturasi': '/dogalgaz-faturasi-hesaplama',
    'jsonFormatter': '/json-bicimlendirici',
    'textCaseConverter': '/metin-harf-donusturucu',
    'urlEncodeDecoder': '/url-encode-decode',
    'base64EncodeDecode': '/base64-encode-decode',
    'uuidGenerator': '/uuid-generator',
    'hashCalculator': '/hash-hesaplayici',
    'qrCodeGenerator': '/qr-kod-olusturucu',
    'imageResizer': '/gorsel-boyutlandirma',
    'textFormatter': '/metin-bicimlendirici',
    'passwordGenerator': '/sifre-uretici',
    'colorPicker': '/renk-secici',
    'timeZoneConverter': '/saat-dilimi-donusturucu',
    'cssMinifier': '/css-minifier',
    'jsBeautifier': '/js-beautifier',
    'textToASCII': '/text-to-ascii',
    'imageCompressor': '/image-compressor',
    'imageFormatConverter': '/image-format-converter',
    'faviconGenerator': '/favicon-generator',
    'fuelConsumption': '/yakit-tuketimi-hesaplama',
    'animalSounds': '/hayvan-sesleri',
    'braSize': '/sutyen-olcusu-hesaplama',
    'desiCalculator': '/desi-hesaplama',
    'obpCalculator': '/obp-hesaplama',
    'turkishCharCleaner': '/turkce-karakter-silme-temizleme-duzeltme'
};
